import Relay from 'react-relay';
/**
*  Update musicPlayer mutation
*/
export default class UpdateMusicPlayerMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      updateMusicPlayer
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        musicPlayerId: this.props.musicPlayerId,
        musicPlayer: {
            ...this.props.musicPlayer
        }
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on updateMusicPlayerPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
        musicPlayer {
            id, 
            name,
            description, 
            status,
            accessMinutes {
                before,
                after
            }
            allowUserAccess
            infrastructures {
                id
            }
            externalId
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/UpdateMusicPlayerMutation.js